import React from "react";

const TicketResolvedEmail: React.FC = () => {
    const htmlContent = `
        <div class="flex justify-center py-8 bg-gray-100 rounded-lg">
            <div class="max-w-[600px] mx-auto bg-white shadow-lg">
                <div class="bg-gradient-to-r from-blue-600 to-blue-700 px-8 py-6">
                    <h1 class="text-white text-2xl font-semibold">Service Desk</h1>
                </div>
                <div class="px-8 py-6">
                    <h2 class="text-2xl font-semibold text-gray-900 mb-4">Your Ticket Has Been Resolved</h2>
                    <p class="text-gray-700 mb-6">Great news! We've resolved your support request. Please review the resolution details below.</p>
                    <div class="border-l-4 p-4 mb-4 bg-green-50 border-green-200 text-green-800">
                        <p class="font-semibold mb-1">Resolution Complete</p>
                        <p class="text-sm">Your issue has been successfully resolved. Please verify the fix works for you.</p>
                    </div>
                    <div class="bg-gray-50 p-4 rounded-md mb-6">
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Ticket ID:</span>
                            <span class="text-gray-900"><span class="font-mono text-blue-600">#SD-2024-1547</span></span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Subject:</span>
                            <span class="text-gray-900">Unable to access customer database</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Resolved By:</span>
                            <span class="text-gray-900">Marcus Chen</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Resolved At:</span>
                            <span class="text-gray-900">May 6, 2026 at 5:45 PM</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Total Time:</span>
                            <span class="text-gray-900">3 hours 15 minutes</span>
                        </div>
                    </div>
                    <div class="mb-6">
                        <h3 class="font-semibold text-gray-900 mb-2">Resolution Summary:</h3>
                        <div class="bg-white border border-green-200 p-4 rounded">
                            <p class="text-gray-700 text-sm mb-3"><strong class="font-semibold">Issue:</strong> User was unable to authenticate to the customer database due to missing permissions.</p>
                            <p class="text-gray-700 text-sm mb-3"><strong class="font-semibold">Root Cause:</strong> Recent security policy update removed database read permissions from the Sales role. Your account needed explicit permissions added.</p>
                            <p class="text-gray-700 text-sm"><strong class="font-semibold">Solution:</strong> I worked with the DBA team to add the necessary permissions to your account (CustomerDB_ReadWrite). Your access has been tested and confirmed working. You should now be able to log in successfully.</p>
                        </div>
                    </div>
                    <div class="mb-6">
                        <h3 class="font-semibold text-gray-900 mb-2">Next Steps:</h3>
                        <ul class="list-disc list-inside text-gray-700 text-sm space-y-1 ml-2">
                            <li>Try logging into the database again</li>
                            <li>Clear your browser cache if you encounter any issues</li>
                            <li>Contact us if the problem persists</li>
                        </ul>
                    </div>
                    <div class="bg-blue-50 border border-blue-200 p-4 rounded mb-6">
                        <h3 class="font-semibold text-gray-900 mb-2">Did this resolve your issue?</h3>
                        <p class="text-sm text-gray-700 mb-3">If your issue is resolved, this ticket will automatically close in 48 hours. If you're still experiencing problems, please click "Reopen Ticket" below.</p>
                        <div class="flex gap-3">
                            <a href="#" class="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md font-medium no-underline transition-colors">Confirm Resolution</a>
                            <a href="?action=reopen" class="inline-block bg-gray-600 hover:bg-gray-700 text-white px-6 py-3 rounded-md font-medium no-underline transition-colors">Reopen Ticket</a>
                        </div>
                    </div>
                </div>
                <div class="bg-gray-50 px-8 py-6 border-t border-gray-200">
                    <p class="text-sm text-gray-600">This is an automated message from the Service Desk. Please do not reply directly to this email.</p>
                </div>
            </div>
        </div>
    `;
    return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

export default TicketResolvedEmail;
